const registrationDev = "http://127.0.0.1:5000/registration";
const loginDev = "http://127.0.0.1:5000/login";
const secretDev = "http://127.0.0.1:5000/secret";
const logoutDev = "http://127.0.0.1:5000/logout/access";

const registration = "/auth/registration";
const login = "/auth/login";
const secret = "/auth/secret";
const logout = "/auth/logout/access";

export function getRegistrationPath () {
    // eslint-disable-next-line no-undef
    if (process.env.NODE_ENV === 'development') {
        return registrationDev;
    } else {
        return registration;
    }
}

export function getLoginPath() {
    // eslint-disable-next-line no-undef
    if (process.env.NODE_ENV === 'development') {
        return loginDev;
    } else {
        return login;
    }
}

export function getSecretPath() {
    // eslint-disable-next-line no-undef
    if (process.env.NODE_ENV === 'development') {
        return secretDev;
    } else {
        return secret;
    }
}

export function getLogoutPath () {
    // eslint-disable-next-line no-undef
    if (process.env.NODE_ENV === 'development') {
        return logoutDev;
    } else {
        return logout;        
    }
}